import React, { useEffect, useState } from "react";
import {
  downloadContentImage,
  getServiceUsersInfo,
} from "../../services/RegistrationService";
import { ServicesTypesComponentLoad } from "../../types/ApplicationTypes";
import { base64ToBlob } from "../../services";
import { WandaUserInfo } from "../../types/PersonTypes";
import ServiceUsers from "../../components/ServiceUsers/ServiceUsers";
import { IServiceUser } from "../../components/ServiceUsers/Interfaces/IServiceUser";
import { ServiceUsersContextProvider } from "../../context/ServiceUsersContext";
import { DefaultAccommodations } from "../../types/ProfileTypes";
import { notification } from "antd";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";

interface Props {
  collapsed: boolean;
  match: any;
}

const defaultUser: IServiceUser = {
  profilePicURL: "",
  personId: 0,
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  age: 0,
  phoneNumber: "",
  email: "",
  homeAddress: "",
  mailingAddress: "",
  wandaAccommodations: DefaultAccommodations(),
};

const ManageServiceUsersContainer: React.FC<Props> = ({ collapsed, match }) => {
  const [serviceData, setServiceData] = useState<WandaUserInfo[]>([]);
  const [parentPersonId, setParentPersonId] = useState<number>(0);
  const [serviceUser, setServiceUser] = useState<IServiceUser>(defaultUser);
  const [loadDataProgress, setLoadDataProgress] = useState(false);
  const [pageType, setPageType] = useState<string>("");

  const { caregiverSummaryInfo, isLoadingPersonData } = usePersonSummaryCtx();

  useEffect(() => {
    if (match.params.id) {
      !isLoadingPersonData && handleManageServiceUsersData();
    }
  }, [match.params.id, isLoadingPersonData]);

  async function handleManageServiceUsersData() {
    setLoadDataProgress(true);
    setParentPersonId(caregiverSummaryInfo.personId);

    try {
      let data = await getServiceUsersInfo(caregiverSummaryInfo.personId);
      let userData = data.filter(
        (x: { personId: number }) => x.personId === Number(match.params.id)
      );

      const getHomeAddress = () => {
        let baseAddress = userData[0].personAttributes.homeAddress;
        const fullAddress = `${baseAddress.address1}
       ${baseAddress.address2 !== null ? baseAddress.address2 : ""}
       ${baseAddress.city}
       ${baseAddress.state}
       ${baseAddress.zip}`;
        return fullAddress;
      };

      const getMailingAddress = () => {
        let baseAddress = userData[0].personAttributes.mailingAddress;
        const fullAddress = `${baseAddress.address1}
      ${baseAddress.address2 !== null ? baseAddress.address2 : ""}
      ${baseAddress.city}
      ${baseAddress.state}
      ${baseAddress.zip}`;
        return fullAddress;
      };

      const serviceUserDetails: IServiceUser = {
        profilePicURL: "",
        personId: userData[0].personId,
        firstName: userData[0].firstName,
        lastName: userData[0].lastName,
        dateOfBirth: userData[0].dateOfBirth,
        age: userData[0].age,
        phoneNumber: userData[0].personAttributes.personContact.primaryPhone,
        email: userData[0].personAttributes.personContact.wandaEmail,
        homeAddress: getHomeAddress(),
        mailingAddress: getMailingAddress(),
        wandaAccommodations: userData[0].wandaAccommodations,
      };
      setServiceUser(serviceUserDetails);

      if (userData[0]?.imageKey) {
        let result = await downloadContentImage(userData[0]?.imageKey);
        const res = result.fileData.split("base64,")[1];
        let parsedFile: Blob = base64ToBlob(res, result.contentType);
        const file = new File([parsedFile], result.filename, {
          type: result.contentType,
        });
        let newdata = [...userData];
        const saveUrl = URL.createObjectURL(file);
        newdata[0].profileImageUrl = saveUrl;
        setServiceData(newdata);
        setServiceUser({ ...serviceUserDetails, profilePicURL: saveUrl });
        setLoadDataProgress(false);
      } else {
        setServiceData(userData);
        setLoadDataProgress(false);
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description:
          "Failed to fetch services user details. Please try again later.",
      });
    }
  }

  return <div>{componentSwitch(pageType)}</div>;

  function componentSwitch(pageType: any) {
    switch (pageType) {
      case ServicesTypesComponentLoad.DashBoard:
        return (window.location.hash = `/DashBoard`);
      case ServicesTypesComponentLoad.ManageServiceUser:
        return (window.location.hash = `/DashBoard/ManageServiceUsers`);
      default:
        return (
          <ServiceUsersContextProvider>
            <ServiceUsers
              parentPersonId={parentPersonId}
              personId={match.params.id}
              serviceUser={serviceUser}
              isLoaded={loadDataProgress}
            />
          </ServiceUsersContextProvider>
        );
    }
  }
};
export default ManageServiceUsersContainer;
